/*
 * @Author: libo 
 * @Date: 2020-11-13 17:44:09 
 * @Last Modified by: mayanxia
 * @Last Modified time: 2023-06-14 14:31:44
 */

<template>
  <a-modal
    :title="$t('操作')"
    :width="1100"
    :ok=false
    :visible="visible"
    :confirmLoading="confirmLoading"
    :okButtonProps="{ props: {disabled: disableSubmit} }"
    @ok="handleOk"
    @cancel="handleCancel"
    :cancelText="$t('关闭')">
    <template slot="footer">
        <a-button key="close" @click="handleCancel">
          {{ $t('关闭') }}
        </a-button>
    </template>
    <a-spin :spinning="confirmLoading">
          <div class="form-contain">
            <a-table 
                :columns="columns"
                :data-source="list"
                :scroll="{x:true}"
                rowKey='id'
                size="middle"
                :pagination="ipagination"
                @change="handleTableChange"
                class="j-table-force-nowrap"
              >
                <span slot="wtPriceSlot" slot-scope="text, record">
                  <span v-if="record.userPriceName"> {{record.userPriceName}}({{record.userPriceTotal?record.userPriceTotal + $t('元'): '--'}})</span>
                  <span v-else>--</span>
                </span>
                <span slot="action" slot-scope="text, record">
                  <a :disabled="!([1,2,3].includes(record.userAccountPayType))" @click="backout(record)">{{ $t('撤销') }}</a>
                  <a-divider type="vertical" />
                  <a :disabled="record.userAccountPayType==1 || record.userAccountPayType==2 || record.userAccountPayType==3" @click="regainBackout(record)">{{ $t('恢复撤销') }}</a>
                </span>
                
            </a-table>  
          </div> 
    </a-spin>
  </a-modal>
</template>

<script>
  import { getAction,putAction } from '@/api/manage'
  import {isUndefined,isNull,isUndefinedAndNull} from'@/utils/validate'
  import DetailList from '@/components/tools/DetailList'
  const DetailListItem = DetailList.Item
  import {payWayObj,payTypeObj} from '@/utils/constants/commonConstant'
  export default {
    name: 'MeterRevocationForm',
    components: {
      DetailListItem,
    },
    data () {
      return {
        list: [],
        title:this.$t("操作"),
        visible: false,
        disableSubmit:false,
        model: {},
        ipagination:{
          current: 1,
          pageSize: 10,
          pageSizeOptions: ['10', '20', '30'],
          showTotal: (total, range) => {
            return range[0] + "-" + range[1] + " " + this.$t('共{total}条', { total: total })
          },
          showQuickJumper: true,
          showSizeChanger: true,
          total: 0
        },
        confirmLoading: false,
        url: {
          add: "/jeecg-charge/meter/meterUserinfo/add",
          edit: "/jeecg-charge/meter/meterUserinfo/edit",
          queryById: "/jeecg-charge/meter/meterUserinfo/queryById",
          doPayTask:"/jeecg-charge/meter/userPay/doPayTask",
          UserRecordList:"/jeecg-charge/meter/meterUserPayRecord/list", //缴费记录查询接口
          doPayCancleTask:"/jeecg-charge/meter/meterUserPayRecord/doPayCancleTask",   //缴费撤销
          doBackPayCancleTask:"/jeecg-charge/meter/meterUserPayRecord/doBackPayCancleTask", //退费撤销
          doFreePayCancleTask:"/jeecg-charge/meter/meterUserPayRecord/doFreePayCancleTask", //补水撤销
          doPayUncancleTask:"/jeecg-charge/meter/meterUserPayRecord/doPayUncancleTask", // 恢复缴费撤销
          doBackPayUncancleTask:"/jeecg-charge/meter/meterUserPayRecord/doBackPayUncancleTask", //恢复退费撤销
          doFreePayUncancleTask:"/jeecg-charge/meter/meterUserPayRecord/doFreePayUncancleTask",  // 恢复补水撤销
        }
      }
    },
    created () {
    },
    computed: {
      // i18n：列标题使用 computed 以响应语言切换
      columns() {
        return [
        {
          title: this.$t('用户编号'),
          dataIndex: 'meterUserId',
          align:"center",
        },
        {
          title: this.$t('表编号'),
          dataIndex: 'meterId',
          align:"center",
        },
        {
          title: this.$t('用户姓名'),
          dataIndex: 'userName',
          align:"center",
        },
        {
          title: this.$t('电话号码'),
          dataIndex: 'userPhone',
          align:"center",
        },
        {
          title: this.$t('购买金额(元)'),
          dataIndex: 'userPayAccountNum',
          align:"center",
          customRender:(t,r,index) => {
            if(!isUndefined(r.userAccountPayType)&&[2,4,6].includes(r.userAccountPayType)) {
              return '-'+t
            }
            return t
          }
        },
        {
          title: this.$t('缴费途径'),
          dataIndex: 'payWay',
          align:"center",
          customRender:(t,r,index) => {
            if(isUndefined(payWayObj[t])) {
              return this.$t('其他')
            }
            return this.$t(payWayObj[t])
          }
        },
        {
          title: this.$t('价格信息'),
          dataIndex: 'wtPrice',
          align:"center",
          scopedSlots: { customRender: 'wtPriceSlot' },
        },
        {
          title: this.$t('购买量(吨)'),
          dataIndex: 'payWaterNum',
          align:"center",
          customRender:(t,r,index) => {
            if(isUndefinedAndNull(t)) {
              return '--'
            }
            if(!isUndefined(r.userAccountPayType)&&[2,4,6].includes(r.userAccountPayType)) {
              return '-'+t
            }
            return t
          }
        },
        // {
        //   title: '订单号',
        //   dataIndex: 'payOrderId',
        //   key: '订单号',
        // },
        {
          title:this.$t('操作类型'),
          dataIndex:'userAccountPayType',
          align:"center",
          customRender:(t,r,index) => {
            if(isUndefined(payTypeObj[t])) {
              return this.$t('其他')
            }
            return this.$t(payTypeObj[t])
          }
        },
        {
          title:this.$t('操作时间'),
          dataIndex:'createTime',
          align:"center",
          customRender:(t,r,index) => {
            // 撤销充值的记录只是修改记录的更新时间等信息，不增加记录，所以需要这样处理现实操作时间
            if(!isNull(r.updateTime)&&r.updateTime!="") {
              return r.updateTime
            }
            return t
          }
        },
        {
          title: this.$t('操作'),
          dataIndex: 'action',
          align:"center",
          fixed:"right",
          width:147,
          scopedSlots: { customRender: 'action' }
        }
        ];
      },
    },
    methods: {
      backout(record) {   //撤销点击事件
        let _this= this
        this.$confirm({
          title: this.$t('你确定要撤销该条记录吗?'),
          content: h => <div style="color:red;"></div>,
          onOk() {
            _this.revocation(record)
          },
          onCancel() {
          }
        });
      },
      regainBackout(record){   //恢复撤销点击事件
        let _this= this
        this.$confirm({
          title: this.$t('你确定要恢复该条记录吗?'),
          content: h => <div style="color:red;"></div>,
          onOk() {
            _this.recoverRevocation(record)
          },
          onCancel() {
          }
        });
      },
      handleOk(e) {
        console.log(e);
        this.visible = false;
      },
      handleTableChange(pagination, filters, sorter) {
        if (Object.keys(sorter).length > 0) {
          this.isorter.column = sorter.field;
          this.isorter.order = "ascend" == sorter.order ? "asc" : "desc"
        }
        this.ipagination = pagination;
        this.queryUserRecordList();
      },
      queryUserRecordList() {  //缴费记录查询
        let params = {}
        params.pageNo = this.ipagination.current;
        params.pageSize = this.ipagination.pageSize;
        params.meterId = this.model.meterId;
        getAction(this.url.UserRecordList, params).then((res) => {
          if(res.success){
            this.list = res.result.records;
            this.ipagination.total = res.result.total;
          }
        })
      },
      edit (record) { 
        this.model = Object.assign({}, record);
        this.visible = true;
        console.log(this.model);
        this.$nextTick(() => {
        // this.form.setFieldsValue(pick(this.model,))
        })
        this.queryUserRecordList();
      },
      revocation(record) {    //撤销操作
        const that = this;
        let data = {id: record.id,userKeyId: record.userKeyId}
        let url = {1: this.url.doPayCancleTask,2: this.url.doBackPayCancleTask,3: this.url.doFreePayCancleTask}
        putAction(url[record.userAccountPayType],data).then((res)=>{
            if(res.success){
              that.$message.success(res.message);
            }else{
              that.$message.warning(res.message);
            }
          }).finally(() => {
            this.queryUserRecordList();
          })
      },
      recoverRevocation(record) {   //恢复撤销操作
        const that = this;
        let data = {id: record.id,userKeyId: record.userKeyId}
        //1恢复充值 2退款 3，补水,4 撤销充值 5 撤销退费 6撤销补水
        let url = {4: this.url.doPayUncancleTask,5: this.url.doBackPayUncancleTask,6: this.url.doFreePayUncancleTask}
        putAction(url[record.userAccountPayType],data).then((res)=>{
          if(res.success){
            that.$message.success(res.message);
          }else{
            that.$message.warning(res.message);
          }
        }).finally(() => {
          this.queryUserRecordList();
        })
      },
      close () {
        this.$emit('close');
        this.disableSubmit = false;
        this.visible = false;
      },
      handleCancel () {
        this.close()
      }
    }
  }
</script>

<style scoped>
.detail-list >>> .content{
  line-height: normal;
}
.form-contain{
    height: 60vh;
    overflow-y: scroll;
    overflow-x: hidden;
}
</style>